// extracted by mini-css-extract-plugin
export var navbarSubLink = "B_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "B_tM d_f0 d_dB";
export var subPageLink = "B_gf d_gf";
export var burger = "B_vY";
export var sublinkSize = "B_vZ";
export var linkSize = "B_v0";
export var Link = "B_rX s_rX s_q8 s_rt";